module.exports = __webpack_public_path__ + "img/no-image.0444d2be.png";